/**
 * Description: 语音输入
 * User: 乐弋
 * Date: 17/03/15
 * Copyright(c) 2017 Taobao.com
 */

import events from 'events';
import util from '../util';

// const WindVane = lib.windvane || {};
const doc = window.document;
const TBVoiceParam = {
  useoldasr: 'true',
  asrkey: 'alicare-demo',
};

/** *
 * 获取客户端相关数据
 */
function checkApp() {
  const ua = window.navigator.userAgent;
  const app = {};
  const aliApp = ua.match(/AliApp\S+\b\)/ig);
  app.is = !!/(T-UA)|(TBIOS)|(WindVane)|(AliApp)/i.test(ua);
  app.name = aliApp ? aliApp[0].match(/\(\w+\-*\w*/)[0].split('(')[1] : '';
  app.version = aliApp ? aliApp[0].match(/(\d+\.*)+/ig)[0] : '';
  return app;
}
/** *
 * 获取客户端类型
 */
function getClient() {
  const app = checkApp();
  if (app.is && app.name === 'TM') {
    return 'tmall';
  } else if (app.is && app.name === 'TB') {
    return 'taobao';
  } else if (app.is && app.name === 'AP') {
    return 'alipay';
  }
  return '';
}

const AppClient = getClient();

export default class VoiceInput extends events {

  constructor() {
    super();

    doc.addEventListener('TBSearchVoice.Event.onRecognizingResult', (ev) => {
      if (ev.param.status === '-2') {
        let text = '';
        if (AppClient === 'taobao') {
          text = '> “手机淘宝” ';
        } else if (AppClient === 'tmall') {
          text = '> “天猫” ';
        }
        util.beealert(`亲，跟小蜜说话，要先前往：你的手机中“设置” > “隐私” > “麦克风” ${text}中打开权限哦`);
        this.emit('cancel');
      } else {
        this.emit('result', ev.param.asr);
      }
    }, false);

    // 监听音量
    doc.addEventListener('TBSearchVoice.Event.onVoiceVolume', (ev) => {
      this.emit('volume', ev.param.volume);
    }, false);

    this.listening = false;
  }

  start() {
    if (this.listening) {
      return;
    }
    if (lib && lib.windvane && lib.windvane.isAvailable) {
      lib.windvane.call('TBSearchVoice', 'startVoiceRecognition',
        TBVoiceParam, () => {
        }, () => {
          this.emit('startError');
        });
      this.emit('start');
      this.listening = true;
    } else {
      this.emit('fatal');
    }
  }

  end() {
    if (!this.listening) {
      return;
    }

    if (lib && lib.windvane && lib.windvane.isAvailable) {
      lib.windvane.call('TBSearchVoice', 'stopVoiceRecognition',
        TBVoiceParam, () => {
        }, () => {
          this.emit('endError');
        });

      this.emit('end');
      this.listening = false;
    }
  }

  cancel() {
    if (!this.listening) {
      return;
    }
    if (lib && lib.windvane && lib.windvane.isAvailable) {
      lib.windvane.call('TBSearchVoice', 'cancelVoiceRecognition',
        TBVoiceParam, () => {
        }, () => {
          this.emit('cancelError');
        });
      this.emit('cancel');
      this.listening = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/voice/voiceinput.js